export default {
  MY_INVESTMENT_UPLOAD_FILE_PROOF_OF_ADDRESS_COMMAND: Symbol.for('MY_INVESTMENT_UPLOAD_FILE_PROOF_OF_ADDRESS_COMMAND'),
  MY_INVESTMENT_UPLOAD_FILE_PROOF_OF_ADDRESS_REPOSITORY: Symbol.for('MY_INVESTMENT_UPLOAD_FILE_PROOF_OF_ADDRESS_REPOSITORY'),
  MY_INVESTMENT_UPLOAD_FILE_PROOF_OF_ADDRESS_STATE_MANAGER: Symbol.for('MY_INVESTMENT_UPLOAD_FILE_PROOF_OF_ADDRESS_STATE_MANAGER'),
  MY_INVESTMENT_UPLOAD_FILE_ACCOUNT_STATUS_COMMAND: Symbol.for('MY_INVESTMENT_UPLOAD_FILE_ACCOUNT_STATUS_COMMAND'),
  MY_INVESTMENT_UPLOAD_FILE_ACCOUNT_STATUS_REPOSITORY: Symbol.for('MY_INVESTMENT_UPLOAD_FILE_ACCOUNT_STATUS_REPOSITORY'),
};
